import { render, staticRenderFns } from "./ActivationBriefProductsPanel.vue?vue&type=template&id=33bb4234&scoped=true&"
import script from "./ActivationBriefProductsPanel.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProductsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefProductsPanel.vue?vue&type=style&index=0&id=33bb4234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb4234",
  null
  
)

export default component.exports